import { hasProp } from "../helpers/Class";

class User {
    constructor(user = null) {
        this.id = !hasProp(user, "id") ? undefined : user.id;
        this.email = !hasProp(user, "email") ? undefined : user.email;
        this.createdAt = !hasProp(user, "createdAt") ? undefined : user.createdAt;
        this.updatedAt = !hasProp(user, "updatedAt") ? undefined : user.updatedAt;
        this.logged = !hasProp(user, "logged") ? undefined : user.logged;
    }
}

export default User;